var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExperimentPlate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 38,
    viewBox: "0 0 47 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.166832 0.333492L0.166829 37.6668L46.8335 37.6668L46.8335 7.3335L39.8335 0.333495L0.166832 0.333492ZM44.5002 35.3335L44.5002 8.50016L38.6668 2.66683L2.50016 2.66683L2.50016 35.3335L44.5002 35.3335Z",
    fill: "#414141"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8335 7.3335L35.1668 7.3335L35.1668 12.0002L39.8335 12.0002L39.8335 7.3335Z",
    fill: "#414141"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5002 7.3335L25.8335 7.33349L25.8335 12.0002L30.5002 12.0002L30.5002 7.3335Z",
    fill: "#414141"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5002 7.33349L21.1668 7.33349L21.1668 12.0002L16.5002 12.0002L16.5002 7.33349Z",
    fill: "#414141"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8335 7.33349L7.16683 7.33349L7.16683 12.0002L11.8335 12.0002L11.8335 7.33349Z",
    fill: "#414141"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8335 16.6668L7.16683 16.6668L7.16683 21.3335L11.8335 21.3335L11.8335 16.6668Z",
    fill: "#414141"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5002 16.6668L21.1668 16.6668L21.1668 21.3335L16.5002 21.3335L16.5002 16.6668Z",
    fill: "#414141"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5002 16.6668L25.8335 16.6668L25.8335 21.3335L30.5002 21.3335L30.5002 16.6668Z",
    fill: "#414141"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1668 16.6668L39.8335 16.6668L39.8335 21.3335L35.1668 21.3335L35.1668 16.6668Z",
    fill: "#414141"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1668 26.0002L39.8335 26.0002L39.8335 30.6668L35.1668 30.6668L35.1668 26.0002Z",
    fill: "#414141"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5002 26.0002L25.8335 26.0002L25.8335 30.6668L30.5002 30.6668L30.5002 26.0002Z",
    fill: "#414141"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1668 26.0002L21.1668 30.6668L16.5002 30.6668L16.5002 26.0002L21.1668 26.0002Z",
    fill: "#414141"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8335 30.6668L11.8335 26.0002L7.16683 26.0002L7.16683 30.6668L11.8335 30.6668Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperimentPlate);
export default __webpack_public_path__ + "static/media/ExperimentPlate.079e4b8f174668c1ca86dbd230561776.svg";
export { ForwardRef as ReactComponent };